<template>
  <div class="bluefire-wap-wrap">
    <wap-header header-text="昆仑数据信息平台" :header-visible="true" :back-visible="true" /><!--参数都可以不传-->
    <div class="pdfview-wrap">
      <pdf-view :src="pdfUrl"></pdf-view>
    </div>
  </div>
</template>
<script>
const header = () => import('./compoments/header');
const pdfView = () => import('@/plugins/pdf/pdf');

export default {
  data() {
    return {
      pdfUrl: ''
    };
  },
  computed: {
  },
  methods: {
  },
  watch: {},
  mounted() {
    this.pdfUrl = this.$route.params.pdfurl;
  },
  components: {
    'wap-header': header,
    pdfView
  }
};
</script>
<style>
  .pdfview-wrap .pdf-canvas{
    width: 100%;
  }
</style>
